import { Http } from "@/network/http"
import { CloseCashBookDto, CreateCashBookDto, UpdateCashBookDto } from "../types"

export const API_PREFIX_PATH = "/cash-book"

export const cashbookServices = {
  // Ping API
  ping: () => {
    return Http.get(`${API_PREFIX_PATH}/ping`)
  },

  // Lấy danh sách sổ quỹ
  getCashBooks: (filters?: any) => {
    return Http.get(`${API_PREFIX_PATH}`, { params: filters })
  },

  // Tạo sổ quỹ cho ngày
  createCashBook: (data: CreateCashBookDto) => {
    return Http.post(`${API_PREFIX_PATH}`, data)
  },

  // Cập nhật sổ quỹ
  updateCashBook: (id: string, data: UpdateCashBookDto) => {
    return Http.put(`${API_PREFIX_PATH}/${id}`, data)
  },

  // Chốt sổ quỹ theo ID
  closeCashBook: (id: string, data: CloseCashBookDto) => {
    return Http.put(`${API_PREFIX_PATH}/${id}/close`, data)
  },

  // Hủy chốt sổ quỹ theo ID
  reopenCashBook: (id: string) => {
    return Http.put(`${API_PREFIX_PATH}/${id}/reopen`, {})
  },

  // Xem sổ quỹ theo ID
  getCashBookById: (id: string) => {
    return Http.get(`${API_PREFIX_PATH}/${id}`)
  },

  // Xem sổ quỹ cho ngày (nếu cần)
  getCashBookDetail: (date: string) => {
    return Http.get(`${API_PREFIX_PATH}/${date}`)
  },

  deleteCashBook: (id: string) => {
    return Http.delete(`${API_PREFIX_PATH}/${id}`)
  },
} 